import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { NavigationService } from '@pc/shared';

export const contactUsNavigationGuard: CanActivateFn = () => {
  const navigationService = inject(NavigationService);
  return !navigationService.isLocked;
};
